module.exports = __webpack_public_path__ + "img/Img15_204469_JcDe-1-5898.55b8235d.jpg";